<template>
    <div class="navbar">
        <router-link to="/analysis/oee" :class="{active : navbar === 4}">
            <Icon type="md-pie" size="18"/>&nbsp;{{$t('a_oeeAnalysisMenu')}}
        </router-link>
        <router-link to="/analysis/ele" :class="{active : navbar === 5}">
            <Icon type="md-flash" size="18"/>&nbsp;{{$t('a_powerAnalysisMenu')}}
        </router-link>
        <router-link to="/analysis/finish" :class="{active : navbar === 6}">
            <Icon type="md-podium" size="18"/>&nbsp;{{$t('a_productAnalysisMenu')}}
        </router-link>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    computed: {
        navbar() {
            return this.$store.state.navbar;
        }
    }
};
</script>





// WEBPACK FOOTER //
// src/views/analysis/components/navbar.vue